import React from 'react';
import { Card, Icon } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { dateFormatter, relativeDate, timeFormatter } from '@/utils/dateHelper';
import EmailIcon from '@/components/EmailIcon';
import Dates from '@/components/hooks/dates';
import { claimStateWithPermissions } from '../state/state';
import TaskClaimButton from './TaskClaimButton';

const TaskCardItemExtra = ({ canEdit, category, task }) => {
  const intl = useIntl();
  const { claimed, canClaim } = claimStateWithPermissions(task, canEdit);
  Dates.useMilliSecondTick(30000);

  return (
    <Card.Content extra>
      <span>
        <Icon
          name="calendar alternate outline"
          title={`${dateFormatter(task.createTime)} - ${timeFormatter(task.createTime)}`}
        />
        {relativeDate(task.createTime, intl, 'created.')}
      </span>
      {claimed && (
      <span className="float-r">
        <EmailIcon email={task.assignee.email} name={task.assignee.name} />
      </span>
      )}
      {!claimed && canClaim && (
        <TaskClaimButton
          basic
          circular
          className="float-r"
          category={category}
          iconOnly
          size="mini"
          claimStatus={task.claimStatus}
          task={task}
        />
      )}
    </Card.Content>
  );
};

export default TaskCardItemExtra;
